import huntingPizzaHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/huntingPizzaHubImage.webp';
import margarittaPizzaHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/margarittaPizzaHubImage.webp';
import havaianPizzaHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/havaianPizzaHubImage.webp';
import trianglesHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/trianglesHubImage.webp';
import batonHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/batonHubImage.webp';
import cheeseMuffinsHubImage from '../../assets/images/AllReciptsImages/RecipesHubImages/cheeseMuffinsHubImage.webp';

export const RecipesHubArr = {
    metaTitle: "рецепти Pastoral",
    metaDescription: "Різноманітні рецепти Pastoral для вашої кухни",
    recipes: [
        {
            link: "hunting-pizza",
            image: huntingPizzaHubImage,
            title: "Піца Мисливська",
            description: "Піца Мисливська — це смачна страва з хрустким коржем, щедро змащеним томатним соусом і оливки. Її начинка включає ароматну мисливську ковбасу, мариновані огірки...",
        },
        {
            link: "margaritta-pizza",
            image: margarittaPizzaHubImage,
            title: "Піца Маргарита",
            description: "Піца Маргарита — це легендарна страва італійської кухні, основою якої є тонке тісто, покрите ароматним томатним соусом, ніжною моцарелою та свіжими листочками базиліку.",
        },
        {
            link: "havaian-pizza",
            image: havaianPizzaHubImage,
            title: "Піца Гавайська",
            description: "Гавайська піца — це неповторне поєднання італійської класики з екзотичним тропічним акцентом. Її основу становить тонке тісто, покрите соковитим томатним соусом і особливим акцентом на солодких ананасах та ніжній шинці.",
        },
        {
            link: "triangles",
            image: trianglesHubImage,
            title: "Трикутники",
            description: "Трикутники — це апетитні хрусткі пиріжки з ніжною, соковитою начинкою, яка прихована всередині тонкого тіста. Гармонія розтопленого твердого сиру та ароматного м'яса створює вибух смаків",
        },
        {
            link: "baton",
            image: batonHubImage,
            title: "Батон",
            description: "Батон — це апетитний хліб довгастої форми з ніжним, пухким м'якушем і хрусткою, золотистою скоринкою. Його запашний аромат під час випікання наповнює оселю затишком",
        },
        {
            link: "Cheese-muffins",
            image: cheeseMuffinsHubImage,
            title: "Сирні кекси",
            description: "Сирні кекси — це легкі й ніжні десерти, які буквально розчиняються на язиці завдяки своїй пухкій, повітряній структурі.",
        },
    ]
}

// хантинг пицца хаб имаге